export default [
    {
        path: 'genders',
        name: 'genders',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.genders.view'],
            translate: (t) => {
                return t('menu_points.genders').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'genders-list'},
        children: [
            {
                path: '',
                name: 'genders-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.view'],
                    translate: (t) => {
                        return t('menu_points.genders').ucFirst();
                    },
                },
                component: () => import('@/views/pages/genders/list.vue')
            },
            {
                path: 'create',
                name: 'gender-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/genders/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'gender-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.genders.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::genders.gender', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/genders/item.vue')
            },
        ]
    },
    {
        path: 'countries',
        name: 'countries',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.countries.view'],
            translate: (t) => {
                return t('menu_points.countries').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'countries-list'},
        children: [
            {
                path: '',
                name: 'countries-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.view'],
                    translate: (t) => {
                        return t('menu_points.countries').ucFirst();
                    },
                },
                component: () => import('@/views/pages/countries/list.vue'),
            },
            {
                path: 'create',
                name: 'country-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::countries.country', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/countries/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'country-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.countries.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::countries.country', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/countries/item.vue')
            },
        ]
    },
    {
        path: 'languages',
        name: 'languages',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.languages.view'],
            translate: (t) => {
                return t('menu_points.languages').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'languages-list'},
        children: [
            {
                path: '',
                name: 'languages-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.view'],
                    translate: (t) => {
                        return t('menu_points.languages').ucFirst();
                    },
                },
                component: () => import('@/views/pages/languages/list.vue'),
            },
            {
                path: 'create',
                name: 'language-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('intl::languages.language', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/languages/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'language-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.languages.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('intl::languages.language', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/languages/item.vue')
            },
        ]
    },
    {
        path: 'zip-codes',
        name: 'zip-codes',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.zip_codes.view'],
            translate: (t) => {
                return t('menu_points.zip_codes').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'zip-codes-list'},
        children: [
            {
                path: '',
                name: 'zip-codes-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.view'],
                    translate: (t) => {
                        return t('menu_points.zip_codes').ucFirst();
                    },
                },
                component: () => import('@/views/pages/zip-codes/list.vue')
            },
            {
                path: 'create',
                name: 'zip-code-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/zip-codes/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'zip-code-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.zip_codes.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::zip_codes.zip_code', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/zip-codes/item.vue')
            },
        ]
    },
    {
        path: 'street-types',
        name: 'street-types',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.street_types.view'],
            translate: (t) => {
                return t('menu_points.street_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'street-types-list'},
        children: [
            {
                path: '',
                name: 'street-types-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.view'],
                    translate: (t) => {
                        return t('menu_points.street_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/street-types/list.vue')
            },
            {
                path: 'create',
                name: 'street-type-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::street_types.street_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/street-types/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'street-type-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.street_types.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::street_types.street_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/street-types/item.vue')
            },
        ]
    },
    {
        path: 'address-types',
        name: 'address-types',
        meta: {
            modules: [],
            authentication_required: true,
            authorization_required: ['roles.address_types.view'],
            translate: (t) => {
                return t('menu_points.address_types').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'address-types-list'},
        children: [
            {
                path: '',
                name: 'address-types-list',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.view'],
                    translate: (t) => {
                        return t('menu_points.address_types').ucFirst();
                    },
                },
                component: () => import('@/views/pages/address-types/list.vue'),
            },
            {
                path: 'create',
                name: 'address-type-create',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('master::address_types.address_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/address-types/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'address-type-edit',
                meta: {
                    modules: [],
                    authentication_required: true,
                    authorization_required: ['roles.address_types.update'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('master::address_types.address_type', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/address-types/item.vue')
            },
        ]
    },
]